<template>
  <div>
    <el-button
      style="position:absolute;"
      plain
      type="single-number"
      @click="dialogTableVisibletextarea = true"
    >
      选择用户
    </el-button>
    <el-dialog
      maxHeight="null"
      width="990px"
      title="用户查询"
      :visible.sync="dialogTableVisibletextarea"
      custom-class="sorting-code-number"
    >
      <div class="el-dialog__body-header">
        <span class="title">用户</span>
        <el-search
          :formProp="form"
          :showIndex="0"
          @search="search"
          @change="change"
          width="380px"
          placement="bottom-start"
        >
          <template slot="search">
            <el-input
              v-model="form.workYears"
              clearable
              searchLabel="工龄"
              placeholder="请输入工龄"
            ></el-input>
            <el-input
              v-model="form.userName"
              clearable
              searchLabel="用户名"
              placeholder="请输入用户名"
            ></el-input>
          </template>
        </el-search>
      </div>
      <div class="el-dialog__body-bodys">
        <div class="bodys-right">
          <el-table
            :data="tableData"
            maxHeight="390"
            :lineClamp="lineClampBody"
            style="width: 950px"
          >
            <el-table-column prop="id" label="主键id"> </el-table-column>
            <el-table-column prop="workYears" label="工龄"> </el-table-column>
            <el-table-column prop="userName" label="用户名"> </el-table-column>
            <el-table-column prop="idNum" label="身份证号"> </el-table-column>
            <el-table-column label="操作" width="70">
              <template slot-scope="scope" style="margin-top: -11px">
                <el-button
                  size="mini"
                  :class="scope.row.button === false ? '' : 'checked'"
                  plain
                  type="single-number-filleted"
                  @click="handleClick(scope.row)"
                  >{{
                    scope.row.button === false ? "选择" : "已选择"
                  }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="table-footer" style="height:30px">
            <div class="ccui-table-footer">
              <el-pagination
                :current-page="pageNoCode"
                :page-size="pageSizeCode"
                :pager-count="5"
                :pagesize="pagesize"
                :total="total"
                @addCurrentPage="internalCurrentPage"
                @current-change="handleCurrentChange"
                @next-click="handleNext"
                @prev-click="handlePrev"
                @size-change="handleSizeChange"
                background
                layout="total, prev, pager, next, jumper"
                next-text="下一页 >"
                popper-class="ccui-paging-page-size-popper"
                prev-text="< 上一页"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogTableVisibletextarea = false"
          >取 消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="inventoryConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
let id = 3;
import { listDemoUserSingleSelectTablePage } from "../../api/";
export default {
  data() {
    return {
      showIndex: "0",
      lineClampBody: true,
      tableData: [],
      searchData: [],
      treeProps: {
        label: "name",
        children: "zones",
        isLeaf: "leaf"
      },
      props: {
        multiple: true,
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          setTimeout(() => {
            const nodes = Array.from({ length: level + 1 }).map(item => ({
              value: ++id,
              label: `选项${id}`,
              leaf: level >= 2
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 1000);
        }
      },
      gridData: [],
      dialogTableVisibletextarea: false,
      form: {
        workYears: "",
        userName: ""
      },
      textarea: "",
      formLabelWidth: "120px",
      pageSizeCode: 10,
      pageNoCode: 0,
      present: "",
      TableData: "",
      total: 0,
      lastTime: {
        button: false
      },
      pagesize: [10]
    };
  },
  methods: {
    inventoryConfirm() {
      this.dialogTableVisibletextarea = false;
      alert(JSON.stringify(this.TableData));
      this.$emit("inventoryConfirm", this.TableData);
    },
    listDemoUserSingleSelectTablePage(item, pageNo) {
      let data = {
        pageSize: this.pageSizeCode,
        pageNo: pageNo ? pageNo : 1,
        workYears: item.workYears, //工龄
        userName: item.userName //用户名
      };

      listDemoUserSingleSelectTablePage(data).then(res => {
        this.TableData = "";
        this.tableData = res.data.data.rows;
        this.total = res.data.data.recordsTotal;
        this.tableData.map(e => {
          e.button = false;
          if (this.TableData.id === e.id) {
            e.button = true;
          }
        });
      });
    },
    handleClick(val) {
      this.TableData = val;
      val.button = true;
      // 取第一个字段作为唯一标识 如果不是手工,手工调整
      if (val.id !== this.lastTime.id) {
        this.lastTime.button = false;
        this.lastTime = val;
      }
      this.tableData = [...this.tableData];
    },
    handleSizeChange(val) {},
    handleNodeClick(val) {
      this.$refs.tree.setCheckedKeys([]);
      this.$refs.tree.setCheckedKeys([val.id]);
    },
    handleCurrentChange(val) {
      this.listDemoUserSingleSelectTablePage(this.searchData, val);
    },
    internalCurrentPage(val) {
      val = 10;
    },
    handlePrev() {},
    handleNext() {},
    handleGoPage() {},
    search(searchData) {
      this.searchData = searchData;
      this.listDemoUserSingleSelectTablePage(searchData);
    },
    change(index, key, value) {
      this.showIndex = index;
    }
  }
};
</script>
